export const NAME = 'leadDetail';
export const USER_HAS_NO_ACCESS_TO_LEAD_ERR_MSG = 'has no access to lead';
